import bulbasaur from "./assets/pokemon/bulbasaur.png";
import squirtle from "./assets/pokemon/squirtle.png";
import charmander from "./assets/pokemon/charmander.png";
import diglett from "./assets/pokemon/diglett.png";
import machop from "./assets/pokemon/machop.png";
import pidgey from "./assets/pokemon/pidgey.png";
import drowzee from "./assets/pokemon/drowzee.png";
import dratini from "./assets/pokemon/dratini.png";
import geodude from "./assets/pokemon/geodude.png";
import jigglypuff from "./assets/pokemon/jigglypuff.png";
import gastly from "./assets/pokemon/gastly.png";
import pikachu from "./assets/pokemon/pikachu.png";

const pokemon = [
  { id: 0, name: "Bulbasaur", img: bulbasaur },
  { id: 1, name: "Squirtle", img: squirtle },
  { id: 2, name: "Charmander", img: charmander },
  { id: 3, name: "Diglett", img: diglett },
  { id: 4, name: "Machop", img: machop },
  { id: 5, name: "Pidgey", img: pidgey },
  { id: 6, name: "Drowzee", img: drowzee },
  { id: 7, name: "Dratini", img: dratini },
  { id: 8, name: "Geodude", img: geodude },
  { id: 9, name: "Jigglypuff", img: jigglypuff },
  { id: 10, name: "Gastly", img: gastly },
  { id: 11, name: "Pikachu", img: pikachu },
];

export default pokemon;
